// extracted by mini-css-extract-plugin
export default {"main":"login_main__ePP28","left-container-login":"login_left-container-login__WuJM1","logo":"login_logo__r+Hjh","right-container-login":"login_right-container-login__OHPOn"};